import React, { useEffect } from 'react';
import { useAnalytics } from './useAnalytics';
import { useUserInfo } from '../user-info';

type AnalyticsProviderProps = {
  children: React.ReactNode;
};

export const AnalyticsIdentityProvider = (props: AnalyticsProviderProps) => {
  const analytics = useAnalytics();
  const userInfo = useUserInfo();
  useEffect(() => {
    analytics.identifyUser(userInfo.engagement_id);
  }, [analytics, userInfo.engagement_id]);
  return props.children;
};
